'use strict';
import angular from 'angular';
import _ from 'lodash';

import multipleMappingsHtmlUrl from './views/multiMappingsList.html';

var app = angular.module('app.multiMappingList.Component', []);

app.component('multiMappingsList', {
    bindings: {
        clientId: "=",
        clusterId: "=",
        serviceId: "=",
        showActions: "=",
        ngModel: "="
    },
    templateUrl: multipleMappingsHtmlUrl,

    // The controller that handles our component logic
    controller: function($ioAlert, anchorSmoothScroll, $location, $timeout, FormService) {
        var self = this;
        self.mappingObj = {
            clientId: self.clientId,
            clusterId:self.clusterId,
            serviceId:self.serviceId,
            selClientItem: {},
            selectedItemId: null,
            selectedClientLabel: ''
        };
        self.advertiserMappingList = [];
        self.showSelect = false;

        function getLineitemPushConnectorClientAccountMapping(){
            FormService.getLineitemPushConnectorClientAccountMapping(self.clusterId, self.clientId, self.serviceId).then(function(response) {
                if(response.values){
                    self.advertiserMappingList = response.values;
                    setSelectedClientLabel();
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not retrieve mappings list.', 'error');
            });
        }

        function setSelectedClientLabel(){
            if(self.mappingObj.selectedItemId){
                var selItem = _.find(self.advertiserMappingList, {item_id: self.mappingObj.selectedItemId});
                if(selItem){
                    self.mappingObj.selectedClientLabel = selItem.item_label;
                    self.ngModel = {id: self.mappingObj.selectedItemId, item_id: selItem.item_id, label:self.mappingObj.selectedClientLabel, service_id: self.serviceId};
                    self.mappingObj.selClientItem = (self.mappingObj.selClientItem.id)?self.mappingObj.selClientItem:selItem;
                }
            }
            if(!self.ngModel.id && self.advertiserMappingList[0]){
                var selItem = self.advertiserMappingList[0];
                self.mappingObj.selectedClientLabel = selItem.item_label;
                self.ngModel = {id: self.mappingObj.selectedItemId, item_id: selItem.item_id, label:self.mappingObj.selectedClientLabel, service_id: self.serviceId};
                self.mappingObj.selClientItem = selItem;
            }
        }

        self.changeClient = function(){
            self.mappingObj.clientId = self.mappingObj.selClientItem.customer_id;
            self.mappingObj.selectedItemId = self.mappingObj.selClientItem.item_id;
            setSelectedClientLabel();
        }

        self.initComponent = function() {

            if(self.ngModel && typeof self.ngModel === 'string' &&  FormService.isValidJsonString(self.ngModel)){
                self.ngModel = JSON.parse(self.ngModel);
                self.serviceId = self.ngModel.service_id;
            }

            if(self.ngModel && self.ngModel.id){
                self.mappingObj.selectedItemId = self.ngModel.item_id;
                self.mappingObj.selectedClientLabel = self.ngModel.label;
            }else {
                self.mappingObj.selectedItemId = null;

                if (self.mappingObj.selectedClientLabel) {
                    self.ngModel = {
                        id: null,
                        item_id: self.mappingObj.selectedItemId,
                        label: self.mappingObj.selectedClientLabel,
                        service_id: self.serviceId
                    };
                } else {
                    self.ngModel = " ";
                }
            }
            getLineitemPushConnectorClientAccountMapping();
        };

        self.initComponent();
    }
});
